
import api from '@/api'
import socket from '@/plugins/socket' // Si se usa socket, descomentar
import router from '@/router'

const state = {
  accessToken: null,
  isAuthenticated: false,
  permisos: [],
}

const getters = {
  accessToken: (state) => state.accessToken,
  isAuthenticated: (state) => !!state.accessToken,
  hasPermiso: state => (permisosRequeridos) => permisosRequeridos.every(permiso => state.permisos.includes(permiso)),
}

const mutations = {
  SET_ACCESS_TOKEN(state, token) {
    state.accessToken = token
  },
  SET_PERMISOS(state, permisos) {
    state.permisos = permisos
  }
}

const actions = {
  async login({ commit, dispatch }, credentials) {

    try {
      const response = await api.auth.login(credentials)
      const TOKEN = response.data.token
      commit('SET_ACCESS_TOKEN', TOKEN)
    } catch (err) {
      console.error('Error login', err)
      throw err
    }
  },

  setPermisos({ commit }, permisos) {
    commit('SET_PERMISOS', permisos)
  },

  logout({ commit, dispatch }) {
    commit('SET_ACCESS_TOKEN', null)
    commit('SET_PERMISOS', [])
    dispatch('usuario/deleteCurrentUser', null, { root: true })

    if (socket.connected) {
      socket.disconnect()
    }

    router.push('/login')
  },

  setAccessToken({ commit }, token) {
    commit('SET_ACCESS_TOKEN', token)
  },

  async forgotPassword({ commit }, email) {
    try {
      const request = await api.auth.forgotPassword(email)
      return request.data.msg
    } catch (err) {
      console.error('Error forgotPassword', err)
      throw err
    }
  },

  async resetPassword({ commit }, { TOKEN, PASSWD }) {
    try {
      const request = await api.auth.resetPassword(TOKEN, PASSWD)
      return request.data.msg
    } catch (err) {
      console.error('Error resetPassword', err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
